import React from "react";
import styles from "./Header.scss";
import { getLocalizedStrings } from "../../centralizedLocalizedString";
let CAN;

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.onHeaderClick=this.onHeaderClick.bind(this);
  }
  onHeaderClick=()=>{
    let details = this.props.accountDetails;
    this.props.onContractAccountClick(details.contractAccountNumber,this.props.isContractAccountExpanded && (details.contractAccountNumber === this.props.contractAccountNumber));
    this.props.onPbToggleOnOffClick(details.bpNumber, details.contractAccountNumber);
    }
    
  render() {
    let details = this.props.accountDetails;
    let strings = getLocalizedStrings("AccountPreference");
    CAN = details.contractAccountNumber;

    let city=(details.city).toLowerCase();
    let state=(details.state);
    let streetAddress=(details.streetAddress).toLowerCase();
    let supplement = details.supplement?details.supplement:null;

    let streetAdd=streetAddress.split(' ');
    let cityAdd=city.split(' ');
    

    function capitalizeFirstLetter(str){
      let n=str.length;
      let s="";
      for(let i=0;i<n;i++){
        if(i<n-1){
        s=s+str[i].charAt(0).toUpperCase()+str[i].substring(1,str[i].length)+" ";
        }
        else{
          s=s+str[i].charAt(0).toUpperCase()+str[i].substring(1,str[i].length);
        }
      }
      return s;
    }
  streetAdd=capitalizeFirstLetter(streetAdd);
  cityAdd=capitalizeFirstLetter(cityAdd);
    let arrow =
      this.props.isMultiAcc === 1 ? (
        <div className={styles.Arrow} >
          {this.props.isContractAccountExpanded && (details.contractAccountNumber === this.props.contractAccountNumber)? (
            <div> <i data-aa-event="accordion" />
            <img className={styles.upArrow} src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/icon_chevron_white.svg'} alt="up arrow" /> </div>
          ) : (
            <div> <i data-aa-event="accordion" />
            <img src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/icon_chevron_white.svg'} alt="down arrow" /> </div>
          )}
        </div>
      ) : null;
     let fullName = details.Name.split(',').slice(0).join(', ');
     let Name= <p className={styles.AccountName} title={fullName}>{app.appUtil.formatNickName(fullName)} </p>;
          
    return (
      <div >
      <button className={styles.buttonTag} onClick={this.onHeaderClick}>
      <div className={styles.AccountDetails} >
        <div className={styles.AccountDetailsContent}>
          <div className={styles.AccountDetailsText}>
              
            {Name}
            <p className={styles.AccountNumber}>
             {" "}
              {strings.Acct} {CAN}
            </p>
           
          </div>
          {/* {arrow} */}
         
        {(details.houseNumber!=="" && details.streetAddress!=="") ?  <div
            className={styles.AccountAddress}
            title={
             
              details.houseNumber +
              " " +
              streetAdd +
              ", " +
              cityAdd +
              ", " +
              details.state +
              " " +
              details.zipcode +
              " " +
              details.supplement
            }
          >
            {details.postBoxNumber && details.postBoxNumber!=='' ? "PO Box " + details.postBoxNumber + "," : ''+ " "}{" "}{details.houseNumber}
            {" "}
            {streetAdd}{", "}{cityAdd}{", "}{details.supplement!==''?details.supplement+ ",":details.supplement}{details.state}{" "}
            {details.zipcode}
          </div>:
         <div
         className={styles.AccountAddress}
         title={
          
           
           cityAdd +
           ", " +
           details.state +
           ", " +
           details.zipcode +
           " " +
              details.supplement
         }
       >
         {/* {details.houseNumber}
         {","}
         {details.streetAddress} , */}
         {details.postBoxNumber && details.postBoxNumber!=='' ? "PO Box " + details.postBoxNumber + "," : ''+ " "}{" "}{cityAdd}{", "}{details.supplement!==''?details.supplement+ ",":details.supplement}{details.state}{" "}
         {details.zipcode}
       </div>}
       {arrow}
          

        </div>
          {/* {this.props.isContractAccountExpanded ? <h1 style={{background:'black'}}>ddd</h1> : null} */}
      </div>
      </button>
      </div>
    );
  }
}
export default Header;
